import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'
import './assets/css/estilos.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify'


Vue.use(Vuetify,{
  theme: {
    primary: '#98579B',
    secondary: '#177D99',
    accent: '#2EBAB0',
    error: '#FF353B',
    info: '#5A345C',
    success: '#57AA65',
    warning: '#F5CB08',
    darken:'#424242'
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
